import type { AgBarSeriesOptions } from 'ag-charts-enterprise';

import { PRIORITY_COLORS } from '@/constants/chartcolors.constants';

export const STACKED_BAR_SERIES: AgBarSeriesOptions[] = [
  {
    type: 'bar',
    xKey: 'date',
    yKey: 'P1',
    yName: 'P1 - Critical',
    stacked: true,
    fill: PRIORITY_COLORS.P1
  },
  {
    type: 'bar',
    xKey: 'date',
    yKey: 'P2',
    yName: 'P2 - High',
    stacked: true,
    fill: PRIORITY_COLORS.P2
  },
  {
    type: 'bar',
    xKey: 'date',
    yKey: 'P3',
    yName: 'P3 - Medium',
    stacked: true,
    fill: PRIORITY_COLORS.P3
  },
  {
    type: 'bar',
    xKey: 'date',
    yKey: 'P4',
    yName: 'P4 - Low',
    stacked: true,
    fill: PRIORITY_COLORS.P4
  },
  {
    type: 'bar',
    xKey: 'date',
    yKey: 'P5',
    yName: 'P5 - Trivial',
    stacked: true,
    fill: PRIORITY_COLORS.P5
  }
];

export const TICKET_CATEGORIES_BAR_SERIES: AgBarSeriesOptions[] = [
  {
    type: 'bar',
    xKey: 'name',
    xName: 'Category',
    yKey: 'count',
    yName: 'Counts',
    direction: 'horizontal',
    fill: '#008ffb'
  }
];

export const TICKET_RESOLUTION_BAR_SERIES: AgBarSeriesOptions[] = [
  {
    type: 'bar',
    xKey: 'name',
    xName: 'Category',
    yKey: 'count',
    yName: 'Counts',
    direction: 'horizontal',
    fill: '#B284BE'
  }
];

export const REMEDIATIONS_STACKED_BAR_SERIES: AgBarSeriesOptions[] = [
  {
    type: 'bar',
    xKey: 'date',
    yKey: 'Critical',
    yName: 'Critical',
    stacked: true,
    fill: PRIORITY_COLORS.P1
  },
  {
    type: 'bar',
    xKey: 'date',
    yKey: 'High',
    yName: 'High',
    stacked: true,
    fill: PRIORITY_COLORS.P2
  },
  {
    type: 'bar',
    xKey: 'date',
    yKey: 'Medium',
    yName: 'Medium',
    stacked: true,
    fill: PRIORITY_COLORS.P3
  },
  {
    type: 'bar',
    xKey: 'date',
    yKey: 'Low',
    yName: 'Low',
    stacked: true,
    fill: PRIORITY_COLORS.P4
  }
];

export default STACKED_BAR_SERIES;
